<template>
	<div>
		<div v-if="isFormLoading" class="panel prog_registration theme-darkgray">
			<div v-if="isFormLoading" class="prog_reg-body theme-light">
				<div class="container">
					<div class="d-flex justify-content-center mb-3">
						<b-spinner variant="primary" label="Loading..." />
					</div>
				</div>
			</div>
		</div>
		<b-container v-else-if="error">
			<b-alert variant="danger" show class="d-flex justify-content-center mt-3 mb-3">
				{{ error.message || error }}
			</b-alert>
		</b-container>
		<div
			v-else
			id="empty-registration"
			class="panel prog_registration theme-darkgray"
		>
			<!-- Появление блока с шагами (checkout-steps) при наведении в область checkout-header -->
			<div v-b-hover="handleHover">
				<checkout-header
					:product="product"
					:form-data="formData"
					:project-type="projectType"
					:count-steps="countSteps"
				/>
				<div class="position-relative">
					<checkout-steps
						v-show="isStepsVisible"
						:form-id="formId"
						:form-data="formData"
						@clickStep="onClickStep"
					/>
				</div>
			</div>
			<!-- Отображение следующих элементов зависит от условий -->
			<!-- Шаги -->
			<!-- Условие делает так, что мы скрываем шаги если нам надо показать
			payment-result, manager-contact или document-info-message -->

			<div ref="stepsContainer">
				<component
					:is="stepComponent"
					v-if="showStep"
					ref="stepComponents"
					:form-data="formData"
					:current-step="step"
					:product="product"
					:sellable-programs="sellablePrograms"
					:event="event"
					:is-payment-result="isPaymentResult"
					:event-form-scenario="eventFormScenario"
					:block="block"
					:fetched-data="fetchedData"
					:sellable-program-ids="sellableProgramIds"
				/>
			</div>

			<!-- Экран после онлайн-оплаты с ожиданием результатов оплаты/сообщением после оплаты -->
			<!-- Условие показа: создан инвойс с типом
			онлайн-оплата (не через счёт), при этом 3-й шаг  -->
			<!-- (т.к. при онлайн оплате человек остаётся на 3-м шаге пока не пройдёт дальше) -->
			<!-- Так же не стоит флаг связи с менеджером
			(возможно излишняя проверка), но лучше не трогать-->
			<payment-result
				v-if="getIsInvoiceCreated(formData.id)
					&& step !== 4
					&& isPaymentResult
					&& !getIsContactManager(formData.id)
					&& !getIsInvoiceTypeInvoice(formData.id)"
				:form-data="formData"
			/>

			<!-- Экран, что с вами свяжется менеджер -->
			<manager-contact
				v-if="getIsContactManager(formData.id)"
				:form-data="formData"
			/>

			<!-- Экран о том, что человеку доступна возможность заполнить документы -->
			<div v-if="getIsShowDocumentInfoMessage(formData.id)" class="prog_reg-body theme-light">
				<document-info-message :form-data="formData" />
			</div>

			<checkout-footer
				v-if="!isFormLoading"
				:form-id="formId"
				:form-data="formData"
				:event="event"
				:is-step-valid="isStepValid"
				:loading="isStepLoading"
				@clickStep="onClickStep"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
import CheckoutFooter from '@/components/checkout/CheckoutFooter.vue';
import CheckoutSteps from '@/components/checkout/Steps.vue';
import CheckoutStep1 from '~/components/checkout/CheckoutStep1.vue';
import CheckoutStep2 from '~/components/checkout/CheckoutStep2.vue';
import CheckoutStep3 from '~/components/checkout/CheckoutStep3.vue';
import CheckoutStep4 from '~/components/checkout/CheckoutStep4.vue';
import PaymentResult from '@/components/checkout/PaymentResult.vue';
import {
	CHECKOUT_STORE_NAMESPACE,
	ACTION_INIT_FORM,
	ACTION_SET_STEP_AND_SYNC_FORM,
	MUTATION_SET_STEP,
	ACTION_SAVE_INITIAL_LEAD_DATA, MUTATION_SET_LOCAL_META_DATA,
} from '@/store/checkout';
import checkoutForm from '@/mixins/checkoutForm';
import ManagerContact from '@/components/checkout/ManagerContact.vue';
import DocumentInfoMessage from '@/components/checkout/DocumentInfoMessage.vue';

const DEFAULT_COUNT_STEPS = 4;

export default {
	name: 'Checkout',
	components: {
		CheckoutHeader,
		CheckoutFooter,
		CheckoutSteps,
		CheckoutStep1,
		CheckoutStep2,
		CheckoutStep3,
		CheckoutStep4,
		// CheckoutStep5,
		// CheckoutStep6,
		PaymentResult,
		ManagerContact,
		DocumentInfoMessage,
	},
	mixins: [checkoutForm],
	props: {
		productId: {
			type: Number,
			default: null,
		},
		formId: {
			type: Number,
			default: null,
		},
		projectType: {
			type: String,
			default: null,
		},
		eventId: {
			type: Number,
			default: null,
		},
		sellableProgramIds: {
			type: Array,
			default: null,
		},
		isPaymentResult: {
			type: Boolean,
			default: false,
		},
		eventFormScenario: {
			type: String,
			default: '',
		},
		block: {
			type: Object,
			default: null,
		},
		fetchedData: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			error: null,
			isStepValid: null,
			formData: {},
			sellablePrograms: [],
			event: {},
			isFormLoading: true,
			isStepsVisible: false,
			isStepLoading: false,
		};
	},
	computed: {
		step() {
			return this.getStep(this.formId);
		},
		showStep() {
			if (!this.step) return false;

			const formId = this.formData.id;
			return (
				!this.getIsInvoiceCreated(formId)
				|| this.step === 4
				|| !this.isPaymentResult
				|| this.getIsInvoiceTypeInvoice(formId)
			)
				&& !this.getIsContactManager(formId)
				&& !this.getIsShowDocumentInfoMessage(formId);
		},
		stepComponent() {
			let { step } = this.$store.state.checkout.formsData.meta[this.formId];
			if (this.formData.reverse_step_4 && step === 3) {
				step = 4;
			} else if (this.formData.reverse_step_4 && step === 4) {
				step = 3;
			}
			return `CheckoutStep${step}`;
		},
		...mapGetters({
			getStep: 'checkout/getStep',
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getFilledStep: 'checkout/getFilledStep',
			getContractSign: 'checkout/getContractSign',
			getIsOrderExists: 'checkout/getIsOrderExists',
			getIsInitialLeadSent: 'checkout/getIsInitialLeadSent',
			getIsInvoiceCreated: 'checkout/getIsInvoiceCreated',
			getIsContactManager: 'checkout/getIsContactManager',
			getProduct: 'checkout/getProduct',
			getIsInvoicePayment: 'checkout/getIsInvoicePayment',
			getIsShowDocumentInfoMessage: 'checkout/getIsShowDocumentInfoMessage',
			getIsInvoiceTypeInvoice: 'checkout/getIsInvoiceTypeInvoice',
		}),
		product() {
			return this.getProduct(this.formData.id);
		},
		countSteps() {
			if (this.formData.disable_step_4) {
				return 3;
			}

			return DEFAULT_COUNT_STEPS;
		},
	},
	watch: {
		step(step, old) {
			if (step !== old) {
				const el = this.$refs.stepsContainer;
				if (el) {
					this.$scrollTo(el);
				}
			}
		},
		showStep(showStep, old) {
			if (showStep !== old && !showStep && this.step === this.countSteps) {
				const el = this.$refs.stepsContainer;
				if (el) {
					this.$scrollTo(el);
				}
			}
		},
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			try {
				await this.getFormData(this.formId, this.eventId, this.sellableProgramIds);
				await this.$store.dispatch(
					`${CHECKOUT_STORE_NAMESPACE}/${ACTION_INIT_FORM}`,
					{
						form: this.formData,
						event: this.event,
						sellablePrograms: this.sellablePrograms,
					},
				);
			} catch (e) {
				this.error = `${e}`;
			} finally {
				this.isFormLoading = false;
			}
		},
		async recognize() {
			const response = await this.$api.checkIsStudent();

			if (response.is_recognized === true) {
				this.$auth.fetchUser();
			}
		},
		async getFormData(formId, eventId, sellableProgramIds) {
			const response = await this.$pagesApi.checkoutFormFetch(formId, eventId, sellableProgramIds);

			this.formData = response.form;
			this.event = response.event;
			this.sellablePrograms = response.sellablePrograms;
		},
		handleHover(hovered) {
			this.isStepsVisible = hovered;
		},
		// eslint-disable-next-line complexity
		async onClickStep(step) {
			this.isStepLoading = true;

			const currentStep = this.step;

			if (step < 1 || step === currentStep) {
				this.isStepLoading = false;
				return;
			}

			this.isStepValid = null;
			if (typeof this.$refs.stepComponents?.checkValidation === 'function') {
				this.isStepValid = this.$refs.stepComponents?.checkValidation();
			}

			/**
			 * Является костылём для "подшага" на 3-м шаге,
			 * когда человек сначала выбрал оплату через счёт, затем
			 * нажал "Далее" и ему показало экран,
			 * что он может заполнить документы. И конкретно это условие возвращает
			 * человека обратно с экрана про документы на экран оплаты через счёт.
			 */
			if (
				currentStep === 3
				&& step === 2
				&& !this.formData.reverse_step_4
				&& this.getIsInvoicePayment(this.formData.id)
				&& this.getIsShowDocumentInfoMessage(this.formData.id)
			) {
				try {
					await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
						formId: this.formData.id,
						localMeta: {
							isShowDocumentInfoMessage: false,
						},
					});
				} finally {
					this.isStepLoading = false;
				}
				return;
			}

			/**
			 * "Конечный шаг", когда человек выбрал оплату через счёт,
			 * и на экране оплаты через счёт нажал "Далее".
			 * При этом 4-й шаг отключен, а все поля заполнены верно.
			 */
			if (
				currentStep === 3
				&& step === 4
				&& !this.formData.reverse_step_4
				&& this.isStepValid === true
				&& this.getIsInvoicePayment(this.formData.id)
				&& this.formData.disable_step_4
			) {
				this.setContactManager();

				try {
					await this.$api.paymentByInvoice({
						formId: this.formData.id,
						uniqueId: this.$store.state.uniqueId.uniqueId,
					});
				} finally {
					this.isStepLoading = false;
				}

				return;
			}

			/**
			 * Является костылём для "подшага" на 3-м шаге,
			 * когда человек выбрал оплату через счёт. Это условие
			 * возвращает человека с экрана оплаты через счёт на экран выбора типа оплаты.
			 * Тут уже есть похожее условие,
			 * только там нет проверки this.isStepValid, getIsInvoicePayment и disable_step_4.
			 * Не совсем понятно как эти три условия влияют,
			 * но на всякий случай оставлю обе группы условий.
			 */
			if (
				currentStep === 3
				&& step === 2
				&& !this.formData.reverse_step_4
				&& this.isStepValid === true
				&& this.getIsInvoicePayment(this.formData.id)
				&& this.formData.disable_step_4
			) {
				try {
					await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
						formId: this.formData.id,
						localMeta: {
							isInvoicePayment: false,
						},
					});
				} finally {
					this.isStepLoading = false;
				}

				return;
			}

			/**
			 * Является костылём для "подшага" на 3-м шаге,
			 * когда человек выбрал оплату через счёт. Это условие
			 * возвращает человека с экрана оплаты через счёт на экран выбора типа оплаты.
			 */
			if (
				currentStep === 3
				&& step === 2
				&& !this.formData.reverse_step_4
				&& this.getIsInvoicePayment(this.formData.id)
			) {
				try {
					await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
						formId: this.formData.id,
						localMeta: {
							isInvoicePayment: false,
						},
					});
				} finally {
					this.isStepLoading = false;
				}

				return;
			}

			if (
				currentStep === 4
				&& step === 3
				&& this.formData.reverse_step_4
				&& this.getIsInvoicePayment(this.formData.id)
			) {
				try {
					await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
						formId: this.formData.id,
						localMeta: {
							isInvoicePayment: false,
						},
					});
				} finally {
					this.isStepLoading = false;
				}

				return;
			}

			/**
			 * "Конечный шаг" - человек заполнил документы на 4-м шаге.
			 */
			if (step > 4 && this.isStepValid === true) {
				this.setContactManager();

				this.isStepLoading = false;
				return;
			}

			/**
			 * Переводит человека с экрана оплаты через счёт на экран о том,
			 * что он может заполнить документы
			 * Так же отправляем на бэкенд информацию, что человек оплатит счётом.
			 */
			if (
				(step === 4 || (currentStep === 4 && step === 3))
				&& !this.formData.reverse_step_4
				&& this.getIsInvoicePayment(this.formData.id)
			) {
				try {
					await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
						formId: this.formData.id,
						localMeta: {
							isShowDocumentInfoMessage: true,
						},
					});

					await this.$api.paymentByInvoice({
						formId: this.formData.id,
						uniqueId: this.$store.state.uniqueId.uniqueId,
					});
				} finally {
					this.isStepLoading = false;
				}

				return;
			}

			/** обычный переход на шаг вперёд */
			if (
				step === currentStep + 1
				&& this.isStepValid === true
				&& step !== 3
				&& this.getIsInitialLeadSent(this.formId)
			) {
				try {
					await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SET_STEP_AND_SYNC_FORM}`, {
						formId: this.formId,
						step,
					});
				} catch (e) {
					this.isStepLoading = false;
					throw e;
				}
			}

			/** отправляем данные в crm при переходе со 2 на 3-й шаг */
			if (step === 3 && this.isStepValid) {
				try {
					console.log(111);
					await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SET_STEP_AND_SYNC_FORM}`, {
						formId: this.formId,
						step,
						event: this.eventFormScenario,
					});
					if (!this.getIsInitialLeadSent(this.formId)) {
						await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_INITIAL_LEAD_DATA}`, {
							formId: this.formId,
							select_landing_id: this.product.crm_landing_id || this.formData.landing_id,
						// step,
						});
					}
				} catch (e) {
					this.isStepLoading = false;
					throw e;
				}
			}

			/** Ставим "максимально-достигнутый" шаг */
			if (step > currentStep + 1 && this.isStepValid === true) {
				const lastStep = this.getFilledStep(this.formId) + 1;
				try {
					await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SET_STEP_AND_SYNC_FORM}`, {
						formId: this.formId,
						step: lastStep,
					});
				} catch (e) {
					this.isStepLoading = false;
					throw e;
				}
			}
			/** обычный переход на шаг назад */
			if (step < currentStep) {
				try {
					await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_STEP}`, {
						formId: this.formId,
						step,
					});
				} finally {
					this.isStepLoading = false;
				}
			}

			this.isStepLoading = false;
		},
	},
};
</script>

<style lang="scss">
@import "~/assets/styles/components/home/prog-registration";
</style>
